import { ref } from "vue";
import type { Position } from "./types";

export function useMenuState() {
  const datePickerVisible = ref(false);
  const datePickerPosition = ref<Position>({ x: 0, y: 0 });
  const isQuickViewDialogVisible = ref(false);

  function showDatePicker(event: MouseEvent) {
    datePickerPosition.value = { x: event.clientX, y: event.clientY };
    datePickerVisible.value = true;
  }

  function hideDatePicker() {
    datePickerVisible.value = false;
  }

  function showQuickView() {
    isQuickViewDialogVisible.value = true;
  }

  function hideQuickView() {
    isQuickViewDialogVisible.value = false;
  }

  return {
    datePickerVisible,
    datePickerPosition,
    showDatePicker,
    hideDatePicker,
    isQuickViewDialogVisible,
    showQuickView,
    hideQuickView,
  };
}
